/* Semantic tokens: roles. This is the layer components and charts read. */
import { band, color, font, light, motion, radius, type } from './primitive';

export const bg = {
  ground: color.void,
  instrument: color.obsidian1,
  raised: color.obsidian2,
  control: color.obsidian3,
  glass: 'rgba(255,255,255,0.035)',
  glassOpaque: 'rgba(14,14,17,0.92)',
} as const;

export const text = { primary: color.ink1, secondary: color.ink2, tertiary: color.ink3 } as const;

export const border = { default: color.hair1, strong: color.hair2, active: color.hair3, focus: color.ink1 } as const;

export const data = { up: color.up, down: color.down } as const;

/** Key levels as light: the flip belongs to the source (white), walls to their side. */
export const level = {
  flip: '#FFFFFF',
  call: color.up,
  put: color.down,
  maxPain: color.ink2,
  expectedMove: color.ink3,
  spot: color.ink1,
} as const;

export const status = { warn: color.down } as const;

export const gridline = color.ink4;

export { band, font, light, motion, radius, type };
